import { authStore } from '$lib/stores/auth';

export const load = async () => {
	// Check auth state from session on app load
	await authStore.checkAuth();
};

export const ssr = false; // Client-side only
export const prerender = false; // Dynamic routing
